// import { useState } from "react";
// import { toast } from "react-toastify";
// import { updateTreeSpeciesApi } from "../../apis/treeSpeciesApi";

// export const useUpdateTreeSpecies = () => {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const updateTreeSpecies = async (id, speciesData) => {
//     setLoading(true);
//     setError(null);

//     const toastId = toast.loading("Updating tree species...");

//     try {
//       const formData = new FormData();
//       Object.entries(speciesData).forEach(([key, value]) => {
//         if (Array.isArray(value)) {
//           value.forEach((v) => formData.append(`${key}[]`, v));
//         } else if (value !== null && value !== undefined) {
//           formData.append(key, value);
//         }
//       });

//       const updated = await updateTreeSpeciesApi(id, formData);

//       toast.update(toastId, {
//         render: "Tree species updated successfully!",
//         type: "success",
//         isLoading: false,
//         autoClose: 3000,
//       });

//       return updated;
//     } catch (err) {
//       const errorMessage =
//         err.response?.data?.detail ||
//         err.response?.data?.data ||
//         err.data ||
//         "Failed to update tree species";

//       toast.update(toastId, {
//         render: errorMessage,
//         type: "error",
//         isLoading: false,
//         autoClose: 5000,
//       });

//       setError(errorMessage);
//       throw err;
//     } finally {
//       setLoading(false);
//     }
//   };

//   return { updateTreeSpecies, loading, error };
// };

import { useState } from "react";
import { toast } from "react-toastify";
import { updateTreeSpeciesApi } from "../../apis/treeSpeciesApi";

export const useUpdateTreeSpecies = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const extractError = (err) => {
    // err is the plain object thrown by projectApi's handleApiError:
      // { status, message, data }
      return {
        title: err.message || "Update Failed",
        issue:
          err.data?.data ||   // "images: The submitted data was not a file..."
          err.message ||
        "Failed to update tree species.",
    };
  };

  const updateTreeSpecies = async (id, speciesData) => {
    setLoading(true);
    setError(null);

    const toastId = toast.loading("Updating tree species...");

    try {
      const formData = new FormData();

        Object.entries(speciesData).forEach(([key, value]) => {

          if (key === "images") return;

          if (value !== undefined && value !== null && value !== "") {
            formData.append(key, value);
          }

        });

        // append images as binary
        if (Array.isArray(speciesData.images)) {
          speciesData.images.forEach((file) => {
            if (file instanceof File) {
              formData.append("images", file);
            }
          });
        }

      const updated = await updateTreeSpeciesApi(id, formData);

      toast.update(toastId, {
        render: (
          <div>
            <strong>Tree Species Updated</strong>
            <div>Tree species updated successfully.</div>
          </div>
        ),
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });

      return updated;
    } catch (err) {
      const { title, issue } = extractError(err);

      toast.update(toastId, {
        render: (
          <div>
            <strong>{title}</strong>
            <div>{issue}</div>
          </div>
        ),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });

      setError({ title, issue });
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { updateTreeSpecies, loading, error };
};